import React from "react";
import "./App.css";
import YotoLogin from "./components/YotoLogin";

function App() {
  return (
    <div className="App">
      <YotoLogin />
    </div>
  );
}

export default App;
